<div class="d-flex">
	<div
		class="align-self-center vw-5 text-center hand-cursor date-nav-btn rounded-pill theme-main-border-color"
		(click)="previousDay()"
		[routerLink]="['/routes/' + etat]"
	>
		<i class="bi bi-chevron-left fs-4" aria-hidden="true"></i>
	</div>
	<div
		class="vw-30 text-center mt-2 hand-cursor date-nav-btn rounded-pill theme-main-border-color"
		(click)="resetDateClick()"
	>
		<span class="theme-main-color">Semaine {{ weekNumber.value }} : </span>
		<span class="fw-bold"
			>{{
				daysFr[selectedDate.getDay()] +
					' ' +
					selectedDate.getDate() +
					' ' +
					monthsFr[selectedDate.getMonth()] +
					' ' +
					selectedDate.getFullYear()
			}}
		</span>
		<span class="fw-bold"> </span>
	</div>
	<div
		class="align-self-center vw-5 text-center hand-cursor date-nav-btn rounded-pill theme-main-border-color"
		(click)="nextDay()"
		[routerLink]="['/routes/' + etat]"
	>
		<i class="bi bi-chevron-right fs-4 vw-5" aria-hidden="true"></i>
	</div>
</div>
